module.exports = __webpack_public_path__ + "static/media/happy2.59e6d5aa.jpg";